export default {
  props: {
    value: {
      type: undefined,
      default: null,
    },
    col: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      default: null,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    isArray: {
      type: Boolean,
      default: false,
    },
    expandedRow: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async toggleEditMode() {
      this.$emit('toggleEditMode');
    },
    async setEditMode(val) {
      this.$emit('setEditMode', val);
    },
  },
};
